import _assign from "object-assign";
var iconTopMargin = {
  touch: 3,
  low: 2,
  medium: 2,
  high: 2
};
var densityToTypeSizePaletteIndex = {
  touch: 70,
  low: 60,
  medium: 50,
  high: 40
};
export var style = function style(_ref) {
  var toolkit = _ref.toolkit,
      zIndex = _ref.zIndex;
  var getElevation = toolkit.elevation.getElevation,
      _toolkit$palette = toolkit.palette,
      type = _toolkit$palette.type,
      white = _toolkit$palette.white,
      grey300 = _toolkit$palette.grey300,
      grey60 = _toolkit$palette.grey60,
      grey900 = _toolkit$palette.grey900,
      blue300 = _toolkit$palette.blue300,
      blue500 = _toolkit$palette.blue500,
      spacing = toolkit.spacing,
      typography = toolkit.typography;
  var buttonBackgroundColor = 'transparent';
  var buttonTextColor = type === 'dark' ? white : grey900;
  var iconColor = type === 'dark' ? grey60 : grey300;

  var createDensityStyle = function createDensityStyle(_ref2) {
    var density = _ref2.density;
    var spacingMixin = spacing[density].spacing;
    var fontSize = typography.size[densityToTypeSizePaletteIndex[density]];
    return {
      '& $buttonLabel': _assign({
        letterSpacing: 0,
        lineHeight: typography.lineHeight,
        fontSize: fontSize,
        minHeight: typography.getMinHeight(fontSize)
      }, typography.getFace()),
      '& $icon': {
        marginTop: "".concat(iconTopMargin[density], "px"),
        boxSizing: 'content-box',
        paddingLeft: spacingMixin(1)
      }
    };
  };

  return {
    /* Styles applied to the root element */
    root: {
      lineHeight: 0,
      position: 'relative',
      display: 'inline-block',
      boxSizing: 'border-box'
    },

    /* Styles applied to the list element */
    listRoot: {
      '&&': {
        boxShadow: getElevation(4, 'blue').boxShadow,
        borderColor: type === 'light' ? blue500 : blue300
      }
    },

    /* Styles applied to a disabled list */
    disabled: {},

    /* Styles applied to the button element */
    button: {
      '&:hover': {
        backgroundColor: buttonBackgroundColor,
        '& $icon': {
          color: iconColor
        }
      },
      '&:active, &.active': {
        backgroundColor: buttonBackgroundColor,
        color: buttonTextColor,
        '& $icon': {
          color: buttonTextColor
        }
      }
    },

    /* Styles applied to the button label element */
    buttonLabel: {
      display: 'inline-block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      textAlign: 'left',
      textTransform: 'none'
    },

    /* Styles applied to the content container */
    content: {
      display: 'flex',
      flex: 1,
      whiteSpace: 'nowrap',
      width: '100%',
      '& $icon': {
        color: iconColor
      }
    },

    /* Styles applied to the root element if keyboard focused */
    focusVisible: {},

    /* Styles applied to the root element when navigating the list with the keyboard */
    formField: {
      outline: 'none'
    },
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the icon element */
    icon: {
      alignSelf: 'center'
    },

    /* Styles applied to the root popper */
    popper: {
      zIndex: zIndex.tooltip - 1
    },

    /* Styles applied to the root element if `density="low"` */
    touchDensity: createDensityStyle({
      density: 'touch'
    }),

    /* Styles applied to the root element if `density="low"` */
    lowDensity: createDensityStyle({
      density: 'low'
    }),

    /* Styles applied to the root element if `density="medium"` */
    mediumDensity: createDensityStyle({
      density: 'medium'
    }),

    /* Styles applied to the root element if `density="high"` */
    highDensity: createDensityStyle({
      density: 'high'
    })
  };
};
//# sourceMappingURL=style.js.map